import { Component, OnInit, NgZone, Input } from '@angular/core';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { NavigationService } from '../../../../services/commons/navigation.service';
import { StorageService } from '../../../../services/commons/storage.service';
import { GlobalVariablesService } from '../../../../services/global-variables.service';
import { ModalController, Platform } from '@ionic/angular';
import { BillsComponent } from './bills/bills.component';
import { UserManualsComponent } from './user-manuals/user-manuals.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { SettingsComponent } from './settings/settings.component';
import { SupportComponent } from './support/support.component';
import { GlobalMethodsService } from '../../../../services/global-methods.service';
import { Instruction } from '../../../../models/Instruction';
import { DefaultModalComponent } from '../../default-modal/default-modal.component';
import { PrivacyPolityComponent } from './privacy-polity/privacy-polity.component';
import { ModalService } from 'src/app/services/commons/modal.service';
import { ProfileInstallationService } from 'src/app/services/commons/profile-installation.service';
import { CookiesComponent } from './cookies/cookies.component';
import { AuthService } from '../../../../services/commons/auth.service';
import { NpsComponent } from '../../nps/nps.component';

@Component({
  selector: 'app-more',
  templateUrl: './more.component.html',
  styleUrls: ['./more.component.scss'],
})
export class MoreComponent implements OnInit {

  public securityKeys: string;
  public confInstallation: string;
  public bills: string;
  public userManuals: string;
  public settings: string;
  public share: string;
  public termsOfUse: string;
  public privacyPolity: string;
  public support: string;
  public logout: string;
  public billsPressed = false;
  public userManualsPressed = false;
  public termsOfUsePressed = false;
  public privacyPolityPressed = false;
  public cookiesPressed = false;
  public settingsPressed = false;
  public supportPressed = false;
  public npsPressed = false;
  public instructions: Instruction[] = [];
  @Input('alarmActivated') alarmActivated; // Home alarm activated -> alarmActivated = true | Home default -> alarmActivated = false
  public _platform: string;
  public pendingMessages = 0;

  constructor(private translate: TranslateConfigService,
    public navigation: NavigationService,
    private storage: StorageService,
    public gvs: GlobalVariablesService,
    private modalCtrl: ModalController,
    private zone: NgZone,
    private infInstallationService: ProfileInstallationService,
    public gms: GlobalMethodsService,
    private defaultModalComponent: DefaultModalComponent,
    public modalService: ModalService,
    public platform: Platform,
    private authService: AuthService) {
      this.gms.footerChatNotifCall$.subscribe(async reception => {
        if (reception > 0){
        this.pendingMessages = this.pendingMessages + reception;
        } else {
          this.pendingMessages = 0;
        }
      });
     }

  ngOnInit() {
  }

  ionViewWillEnter() {
  }
  async goLogout() {
    this.modalService.closeAllOpenModals();
    const checkInternet = await this.gms.checkInternet();
    const userLogin = await this.authService.getUserLogin(this.gvs.user);
    if (checkInternet) {
      if (await this.authService.logOut()) {
        console.log("Device logged out successfully.");
      }
      else {
        console.log("Device could not be logged out.");
      }
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
    await this.authService.setBiometricLogin(userLogin.userName, false);
    await this.storage.setObject('FIRST_USE', 1);
    await this.navigation.logout(true, userLogin);
    // this.modalCtrl.dismiss({ result: true });
  }

  async closeOptions() {
    if (this.billsPressed || this.userManualsPressed || this.termsOfUsePressed || this.settingsPressed || this.supportPressed || this.privacyPolityPressed || this.cookiesPressed) {
      this.modalService.closeAllOpenModals();

      this.billsPressed = false;
      this.userManualsPressed = false;
      this.termsOfUsePressed = false;
      this.settingsPressed = false;
      this.supportPressed = false;
      this.privacyPolityPressed = false;
      this.cookiesPressed = false;
    }
  }

  // Default modal
  async openBillsModal() {
    if (!this.modalService.isOpeningModal){
      if (!this.billsPressed) {
        await this.closeOptions();
        this.billsPressed = true;
        // open modal bills
        const contentModal = await this.modalService.show(BillsComponent, "billsModal", {alarmActivated: this.alarmActivated}, this.alarmActivated ? ['modal-default', 'main-menu-modal', 'alarmActivated'] : ['modal-default', 'main-menu-modal']);
        contentModal.onDidDismiss().then(data => {
          this.zone.run(async () => {
            if (data.data === null){
              return;
            }
            await this.gms.startIntervalSatusInstallationEvent();
            this.billsPressed = false;
            // await this.modalService.hide("billsModal");
          });
        });
        contentModal.present().then();
      } else {
        this.modalService.hide("billsModal");
      }
    }
  }

  // Default modal
  async openUserManualsModal() {
    if (!this.modalService.isOpeningModal){
      if (!this.userManualsPressed) {
        await this.closeOptions();
        this.userManualsPressed = true;
        const contentModal = await this.modalService.show(UserManualsComponent, "userManualsModal", {}, this.alarmActivated ? ['modal-default', 'main-menu-modal', 'alarmActivated'] : ['modal-default', 'main-menu-modal']);
        contentModal.onDidDismiss().then(data => {
          this.zone.run(async () => {
            if (data.data === null){
              return;
            }
            await this.gms.startIntervalSatusInstallationEvent();
            this.userManualsPressed = false;
            // this.modalService.hide("userManualsModal");
          });
        });

        contentModal.present().then();
      } else {
        this.modalService.hide("userManualsModal");
      }
    }
  }

  // Default modal
  async openTermsOfUseModal() {
    if (!this.modalService.isOpeningModal){
      if (!this.termsOfUsePressed) {
        const checkInternet = await this.gms.checkInternet();
        if (checkInternet) {
          await this.closeOptions();
          this.termsOfUsePressed = true;
          this.instructions = await this.infInstallationService.gAppuserText(this.gvs.user.userName, this.gvs.lang, 8, 'SIC1400_0010', 'terms');
          if (this.instructions != null && this.instructions.length > 0) {
            const contentModal = await this.modalService.show(TermsOfUseComponent, "termsModal", { terms: this.instructions[0].texts }, this.alarmActivated ? ['modal-default', 'main-menu-modal', 'alarmActivated'] : ['modal-default', 'main-menu-modal']);
            contentModal.onDidDismiss().then(res => {
              this.zone.run(async () => {
                if (res.data === null){
                  return;
                }
                await this.gms.startIntervalSatusInstallationEvent();
                this.termsOfUsePressed = false;
                if (res.data != null && res.data.result) {
                  this.navigation.goHome();
                }
              });
            });

            contentModal.present().then();
          } else {
            await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.downloadTermsOfUserKo'),
              'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
          }
        } else {
          await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
        }
      } else {
        this.modalService.hide("termsModal");
      }
    }
  }

  // Default modal
  async openSettingsModal() {
    if (!this.modalService.isOpeningModal){
      if (!this.settingsPressed) {
        await this.closeOptions();
        this.settingsPressed = true;
        const contentModal = await this.modalService.show(SettingsComponent, "settingsModal", {}, this.alarmActivated ? ['modal-default', 'main-menu-modal', 'alarmActivated'] : ['modal-default', 'main-menu-modal']);

        contentModal.onDidDismiss().then(data => {
          this.zone.run(async () => {
            if (data.data === null){
              return;
            }
            await this.gms.startIntervalSatusInstallationEvent();
            this.settingsPressed = false;
          });
        });

        contentModal.present().then();
      } else {
        this.modalService.hide("settingsModal");
      }
    }
  }

  // Default modal
  async openSupportModal() {
    if (!this.modalService.isOpeningModal){
      if (!this.supportPressed) {
        await this.closeOptions();
        this.supportPressed = true;
        const contentModal = await this.modalService.show(SupportComponent, "supportModal", {}, this.alarmActivated ? ['modal-default', 'main-menu-modal', 'alarmActivated'] : ['modal-default', 'main-menu-modal']);

        contentModal.onDidDismiss().then(data => {
          this.zone.run(async () => {
            if (data.data === null){
              return;
            }
            await this.gms.startIntervalSatusInstallationEvent();
            this.supportPressed = false;
          });
        });

        contentModal.present().then();
      } else {
        this.modalService.hide("supportModal");
      }
    }
  }

  async openPrivacyPolity() {
    if (!this.modalService.isOpeningModal){
      if (!this.privacyPolityPressed) {
        const checkInternet = await this.gms.checkInternet();
        if (checkInternet) {
          await this.closeOptions();
          this.privacyPolityPressed = true;
          this.instructions = await this.infInstallationService.gAppuserText(this.gvs.user.userName, this.gvs.lang, 24, 'SIC1400_0020', 'priva');
          if (this.instructions != null && this.instructions.length > 0) {
            const contentModal = await this.modalService.show(PrivacyPolityComponent, "privacyModal", { priva: this.instructions[0].texts }, this.alarmActivated ? ['modal-default', 'main-menu-modal', 'alarmActivated'] : ['modal-default', 'main-menu-modal']);

            contentModal.onDidDismiss().then(res => {
              this.zone.run(async () => {
                if (res.data === null){
                  return;
                }
                await this.gms.startIntervalSatusInstallationEvent();
                this.privacyPolityPressed = false;
                if (res.data != null && res.data.result) {
                  this.navigation.goHome();
                }
              });
            });

            contentModal.present().then();
          } else {
            await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.downloadPrivacyPolityKo'),
              'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
          }
        } else {
          await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
        }
      } else {
        this.modalService.hide("privacyModal");
      }
    }
  }

  async openCookies() {
    if (!this.modalService.isOpeningModal){
      if (!this.cookiesPressed) {
        const checkInternet = await this.gms.checkInternet();
        if (checkInternet) {
          await this.closeOptions();
          this.cookiesPressed = true;
          this.instructions = await this.infInstallationService.gAppuserText(this.gvs.user.userName, this.gvs.lang, 45, 'SIC1400_0030', 'cookies');
          if (this.instructions != null && this.instructions.length > 0) {
            const contentModal = await this.modalService.show(CookiesComponent, "cookiesModal", { cookies: this.instructions[0].texts }, this.alarmActivated ? ['modal-default', 'main-menu-modal', 'alarmActivated'] : ['modal-default', 'main-menu-modal']);

            contentModal.onDidDismiss().then(res => {
              this.zone.run(async () => {
                await this.gms.startIntervalSatusInstallationEvent();
                this.cookiesPressed = false;
                if (res.data != null && res.data.result) {
                  this.navigation.goHome();
                }
              });
            });

            contentModal.present().then();
          } else {
            await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.downloadCookiesKo'),
              'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
          }
        } else {
          await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
        }
      } else {
        this.modalService.hide("cookiesModal");
      }
    }
  }

  async goToGeoAround(){
    if (this.platform.is('cordova')) {
      this.navigation.goTo('/geo-around');
      this.gms.analyticsTrackEvent('more', {eventCategory: 'SICOR/Menu Mas', eventAction: 'Accion/Geocerca Click'});
    }else{
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), await this.translate.getTranslate('MESSAGES.accessDenied'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  async openNps() {
    if (!this.modalService.isOpeningModal){
      if (!this.npsPressed) {
        await this.closeOptions();
        this.npsPressed = true;
        // open modal NPS
        const contentModal = await this.modalService.show(NpsComponent, "npsModal", {user: this.gvs.user, currentInstallation: this.gvs.currentInstallation, showModal: true}, ['w-modal-md', 'hd-modal']);
        contentModal.onDidDismiss().then(resp => {
          this.zone.run(async () => {
            this.npsPressed = false;
            if (resp != null && resp.data != null && resp.data.result != null && resp.data.result.value != null) {
              if(resp.data.result.value){
                await this.storage.setItem(this.gvs.NPS_VIEW, '0');
                await this.gms.setStatusNpsEvent('0');
              }
            }else{
              return;
            }
          });
        });
        contentModal.present().then();
      } else {
        this.modalService.hide("npsModal");
      }
    }
  }

}
